import { useBrand } from "../../../../../common/providers/brand/brand-context";
import { useMemo } from "react";

// there is not a good place to share the height of the reserved
// area in immersive reader and that same value passed to mosaic
// at least here it is together in one place

export default function useStaticPadding() {
  const brand = useBrand();
  const top = useMemo(
    () =>
      brand.getProp("Reader") === "Immersive" &&
      brand.getProp("Immersive.Toolbar.enabled")
        ? 82
        : 0,
    [brand]
  );

  return { top };
}
